import { Component, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { auth } from 'firebase/app';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {

  constructor(
    public afAuth: AngularFireAuth,
    public dialogRef: MatDialogRef<AuthComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    console.log('data in dialog: ', data.mode);
  }

  login() {
  }
  logout() {
    this.afAuth.signOut();
  }

  signUpWithGoogle() {
    this.afAuth.signInWithPopup(new auth.GoogleAuthProvider());
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
